import { render, staticRenderFns } from "./BizInvoiceinfoList1.vue?vue&type=template&id=56ef5c45&"
import script from "./BizInvoiceinfoList1.vue?vue&type=script&lang=js&"
export * from "./BizInvoiceinfoList1.vue?vue&type=script&lang=js&"
import style0 from "./BizInvoiceinfoList1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports